import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isURL } from 'validator';

import { getMeetingPlatform } from './meeting-platform';

export function validateMeetingLink(control: AbstractControl): ValidationErrors | null {
  const value = control.value?.trim();
  if (!value) return null;

  if (!isURL(value, { protocols: ['http', 'https'], require_protocol: true })) return { invalidUrl: true };

  return getMeetingPlatform(value) ? null : { unsupportedPlatform: true };
}
